import { registerPlugin } from '@capacitor/core';

interface IFacebookLoginPlugin {
  login: () => Promise<void>;
  getProfile: () => Promise<IUserInfos>;
}

export const FacebookLoginPlugin = registerPlugin<IFacebookLoginPlugin>('FacebookLoginPlugin');
